import { Link } from "react-router-dom";
import StatusIcon from "./StatusIcon";

const StepItem = ({
  step,
  index,
  isDisabled,
  userStatus,
  firstIncompleteIndex,
}) => {
  console.log("StepItem userStatus ", userStatus);
  const status = userStatus?.[step.key] || "Upload";

  const commonClasses = `flex items-center justify-between rounded-xl border-2 px-6 py-5 shadow-md transition focus:outline-none ${
    isDisabled
      ? "opacity-60 cursor-not-allowed border-gray-300 bg-gray-100"
      : "border-indigo-400 bg-indigo-50 hover:bg-indigo-100 focus:ring-4 focus:ring-indigo-300"
  }`;

  const Content = (
    <div className="flex items-center gap-5">
      <span className="text-3xl">
        <StatusIcon
          index={index}
          keyName={step.key}
          userStatus={userStatus}
          firstIncompleteIndex={firstIncompleteIndex}
        />
      </span>
      <div className="flex flex-col">
        <span className="text-lg font-semibold text-indigo-900">
          {step.label}
        </span>
        <span className="text-sm text-gray-600">Status: {status}</span>
      </div>
    </div>
  );

  const Arrow = (
    <span className="text-3xl text-indigo-500 font-bold select-none">
      &rarr;
    </span>
  );

  return isDisabled ? (
    <div className={commonClasses} aria-disabled="true" tabIndex={-1}>
      {Content}
      {Arrow}
    </div>
  ) : (
    <Link
      to={step.link}
      className={commonClasses}
      tabIndex={0}
      onFocus={(e) => (e.currentTarget.style.outline = "none")}
    >
      {Content}
      {Arrow}
    </Link>
  );
};

export default StepItem;
